export default function* selectMany(iterable, selector) {
    for (const item of iterable) {
        const inner = selector(item);
        for (const inner_item of inner) {
            yield inner_item;
        }
    }
}
